import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "alert alert-warning text-dark",
  role: "alert"
}

import { computed, toRef } from 'vue'

    import FormDependenciesList from '@Alternatives/Forms/Components/FormDependenciesList.vue'

    import type { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { FormDependenciesDialogViewModel } from '@Alternatives/Forms/Components/FormDependenciesDialog'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FormDependenciesDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)
    const name = computed(() => vm.value.name)

    const deps = computed<FormDefDependenciesReadModel | null>(() => vm.value.deps)
    const dependantsCount = computed<number | null>(() => deps.value?.Count ?? null)

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Form dependencies", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, [
                          _cache[2] || (_cache[2] = _createTextVNode(" The form '", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(dependantsCount.value), 1 /* TEXT */),
                          _cache[4] || (_cache[4] = _createTextVNode(" places. ", -1 /* CACHED */))
                        ])
                      ]),
                      _createVNode(FormDependenciesList, { readModel: deps.value }, null, 8 /* PROPS */, ["readModel"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})